import React from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'

const Logistics = () => {
  return (
    <div>
      <Helmet>
        <title>Logistics | Trans World Shipping</title>
        <meta name="description" content="Comprehensive logistics solutions for your international shipping needs." />
        <link rel="canonical" href="https://transworldshippingcompany.com/services/logistics" />
      </Helmet>
      
      <TheLogistics>
        <div className="logistics-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Logistics</h1>
            <p>World-class contract logistics and distribution provider</p>
          </div>
        </div>

        <div className="logistics-container">
          <div className="intro-text">
            <p>We are a world-class contract logistics and distribution provider.</p>
          </div>

          <div className="process-section">
            <h2>Our Process</h2>
            <div className="header-line"></div>
            <p>
              We process your shipments and products to their final destination with the help of 
              our integrated supply chain management systems, utilizing the combined methods of:
            </p>
            
            <div className="methods-grid">
              <div className="method-item">Oceanfreight</div>
              <div className="method-item">Airfreight</div>
              <div className="method-item">Barge</div>
              <div className="method-item">Rail transportation</div>
              <div className="method-item">Warehousing</div>
              <div className="method-item">Trucking services</div>
            </div>
            
            <p className="efficiency-text">to achieve maximum efficiency.</p>
          </div>

          <div className="delivery-section">
            <p>Just in time delivery into production lines and industrial construction sites.</p>
            <p className="key-projects">Key turn projects</p>
          </div>

          <div className="tracking-section">
            <p>
              The logistics process is supported by LIVE track and trace, and via satellite for remote areas, 
              making it possible to know the exact location of your shipment at all times.
            </p>
          </div>

          <div className="representative-section">
            <p>
              Every client is assigned a qualified personal senior representative for the entire operation 
              from beginning to end, ensuring total satisfaction.
            </p>
          </div>

          <div className="control-section">
            <p>We are in control</p>
            <p className="clients">Serving over 100 multi-national organizations around the globe.</p>
          </div>
        </div>
      </TheLogistics>
    </div>
  )
}

const TheLogistics = styled.div`
  width: 100%;
  background: #ffffff;

  .logistics-hero {
    position: relative;
    width: 100%;
    height: 40vh;
    min-height: 300px;
    background: linear-gradient(135deg, #0B1E33 0%, #0a1a2c 100%);
    
    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(circle at 30% 50%, rgba(212, 175, 55, 0.1) 0%, transparent 70%);
    }
    
    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      width: 100%;
      padding: 0 2rem;
      z-index: 1;
      
      h1 {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 1rem;
      }
      
      p {
        font-size: 1.2rem;
        opacity: 0.9;
      }
    }
  }

  .logistics-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .intro-text {
    text-align: center;
    margin-bottom: 3rem;
    
    p {
      font-size: 1.3rem;
      color: #0B1E33;
      font-weight: 600;
      line-height: 1.5;
    }
  }

  .process-section {
    text-align: center;
    margin-bottom: 3rem;
    
    h2 {
      font-size: 2rem;
      color: #0B1E33;
      margin-bottom: 1rem;
      font-weight: 700;
    }
    
    .header-line {
      width: 60px;
      height: 3px;
      background: #D4AF37;
      margin: 0 auto 1.5rem;
    }
    
    p {
      font-size: 1rem;
      color: #4a5568;
      line-height: 1.7;
      margin-bottom: 2rem;
    }
    
    .methods-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 1rem;
      max-width: 600px;
      margin: 0 auto 1.5rem;
      
      .method-item {
        background: #f8f9fa;
        padding: 0.75rem;
        border-radius: 8px;
        font-size: 0.95rem;
        color: #0B1E33;
        font-weight: 500;
        border: 1px solid #e2e8f0;
        transition: all 0.3s ease;
        
        &:hover {
          border-color: #D4AF37;
          transform: translateY(-2px);
        }
      }
    }
    
    .efficiency-text {
      font-weight: 500;
      color: #D4AF37;
      margin-top: 1rem;
    }
  }

  .delivery-section {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 2rem;
    
    p {
      font-size: 1rem;
      color: #4a5568;
      margin-bottom: 0.5rem;
    }
    
    .key-projects {
      font-weight: 600;
      color: #0B1E33;
      font-size: 1.1rem;
    }
  }

  .tracking-section {
    background: linear-gradient(135deg, #0B1E33 0%, #0a1a2c 100%);
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 2rem;
    
    p {
      color: white;
      font-size: 1rem;
      line-height: 1.7;
    }
  }

  .representative-section {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 2rem;
    
    p {
      font-size: 1rem;
      color: #4a5568;
      line-height: 1.7;
    }
  }

  .control-section {
    text-align: center;
    padding: 2rem;
    
    p {
      font-size: 1rem;
      color: #4a5568;
      margin-bottom: 1rem;
      
      &:first-child {
        font-size: 1.3rem;
        font-weight: 700;
        color: #0B1E33;
      }
    }
    
    .clients {
      font-weight: 600;
      color: #D4AF37;
    }
  }

  @media screen and (max-width: 900px) {
    .logistics-hero .hero-content h1 {
      font-size: 2.5rem;
    }
    
    .logistics-container {
      padding: 3rem 1.5rem;
    }
    
    .intro-text p {
      font-size: 1.1rem;
    }
    
    .process-section h2 {
      font-size: 1.6rem;
    }
    
    .methods-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media screen and (max-width: 768px) {
    .logistics-hero {
      min-height: 250px;
      
      .hero-content h1 {
        font-size: 2rem;
      }
      
      .hero-content p {
        font-size: 1rem;
      }
    }
    
    .logistics-container {
      padding: 2rem 1rem;
    }
    
    .delivery-section,
    .tracking-section,
    .representative-section {
      padding: 1.5rem;
    }
  }

  @media screen and (max-width: 600px) {
    .logistics-hero .hero-content h1 {
      font-size: 1.6rem;
    }
    
    .intro-text p {
      font-size: 1rem;
    }
    
    .process-section h2 {
      font-size: 1.3rem;
    }
    
    .methods-grid {
      grid-template-columns: 1fr;
      gap: 0.75rem;
    }
    
    .control-section p:first-child {
      font-size: 1.1rem;
    }
  }

  @media screen and (max-width: 480px) {
    .logistics-hero .hero-content h1 {
      font-size: 1.3rem;
    }
    
    .logistics-hero .hero-content p {
      font-size: 0.9rem;
    }
  }
`;

export default Logistics;